"use strict";
import "src/decidim/index";
import "src/decidim/decidim_application";
import "entrypoints/decidim_core.scss";
require.context("../images", true);
